export default {
  title: "Business numbers",

  input: {
    title: "{{action}} business numbers",
    chamberOfCommerce: {
      label: "CoC",
      unknown: "No chamber of commerce number available",
    },
    vat: {
      label: "VAT",
      unknown: "No VAT number available",
    },
  },
}
